export default "__VITE_ASSET__Dy3xJvTX__"